import * as React from 'react'
import Logo from 'components/shared/logo'
import ProfileMenu from 'components/shared/profile-menu'

export const AppBarHeightPixel = 64

const AppBar = () => {
    return (
        <nav style={{ height: `${AppBarHeightPixel}px` }} className="w-full border-b z-40 mb-3 flex items-center">
            <div className="w-full flex justify-between ">
                <div className="flex w-11/12 md:w-9/12 mx-auto">
                    <div className="flex-1 flex">
                        <Logo />
                    </div>
                    <div className="hidden sm:flex">
                        <ProfileMenu />
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default AppBar
